// extracted by mini-css-extract-plugin
module.exports = {"skill":"SkillHeader_skill__1zNTb"};